import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import { type FormSubmitType, store } from "..";
import { setFormLoading, setForms } from "../slices/formSlice";

export const getForms = async (notify: MessageInstance) => {
  try {
    store.dispatch(setFormLoading(true));
    const response = await privateAPI.get("/forms/all");
    if (response) {
      store.dispatch(setFormLoading(false));
      store.dispatch(setForms(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setFormLoading(false));
    console.error("Get Form Error:", error);
    errorHandler(error, notify);
  }
};

export const createForm = async (
  notify: MessageInstance,
  payload: FormSubmitType,
) => {
  try {
    store.dispatch(setFormLoading(true));
    const { data } = await privateAPI.post("/forms", payload);
    notify.success("Form created successfully!");
    return data;
  } catch (error) {
    console.error("Create Form Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setFormLoading(false));
  }
};

export const updateForm = async (
  notify: MessageInstance,
  payload: FormSubmitType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setFormLoading(true));
    const { data } = await privateAPI.put(`/forms/${payload.id}`, payload);
    notify.success("Form updated successfully!");
    return data;
  } catch (error) {
    console.error("Update Form Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setFormLoading(false));
  }
};

export const deleteForm = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setFormLoading(true));
    const response = await privateAPI.delete(`/forms/${id}`);
    if (response) {
      getData && (await getForms(notify));
    }
    notify.success("Form deleted successfully!");
    return response;
  } catch (error) {
    console.error("Delete Form Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setFormLoading(false));
  }
};

export const uploadFormCsv = async (
  notify: MessageInstance,
  payload: FormData,
) => {
  try {
    store.dispatch(setFormLoading(true));
    const response = await privateAPI.post(`/forms/bulk-upload`, payload);
    if (response) {
      await getForms(notify);
    }
    notify.success("Forms uploaded successfully!");
    return response;
  } catch (error) {
    console.error("Forms upload Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setFormLoading(false));
  }
};

export const formGenerateFromDocument = async (
  notify: MessageInstance,
  url: string,
) => {
  try {
    store.dispatch(setFormLoading(true));
    const response = await privateAPI.post(`/forms/openai`, { url });
    if (response) {
      await getForms(notify);
    }
    notify.success("Form generated successfully!");
    return response;
  } catch (error) {
    console.error("Forms Generate Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setFormLoading(false));
  }
};
